export default __webpack_public_path__ + "static/media/angel.d53ef81c.jpeg";